
// * Manage Users 그리드 컬럼 정의 
export const manageUsersGridColumns = [
  { title: 'Name', key: 'name', width: 120 },
  { title: 'Email', key: 'email', width: 180  },
  { title: 'Login', key: 'loginMethod', width: 100 },
  { title: 'Email Verified', key: 'emailVerified', width: 120 },
  { title: 'Status', key: 'status', width: 100 },
  { title: 'Reserved Schedules', key: 'reservedSchedules', width: 140 },
  { title: 'Payment History', key: 'paymentHistory', width: 120 },
  { title: 'Actions', key: 'actions', width: 80 },
];

// * User Permission 그리드 컬럼 정의 
export const userPermissionGridColumns = [
  { title: 'Name', key: 'name', width: 100 },
  { title: 'Email', key: 'email', width: 150 },
  { title: 'Login', key: 'loginMethod', width: 80 },
  { title: 'Email Verified', key: 'emailVerified', width: 100 },
  { title: 'Status', key: 'status', width: 80 },
  { title: 'Role', key: 'role', width: 120 },
];

// * Menu Visibility 그리드 컬럼 정의
export const menuVisibilityGridColumns = [
  { title: 'Menu', key: 'title', width: 120 },
  { title: 'User', key: 'user', width: 40 },
  { title: 'Admin', key: 'admin', width: 60 },
];

// * 권한 리스트
export const roleList = [
  { value: 1, label: 'USER' },
  { value: 2, label: 'ADMIN' }
]